import React from "react";
import kidney from "../../assets/images/kidney.png";
import prostate from "../../assets/images/prostate.png";
import infertility from "../../assets/images/infertility.png";
import uti from "../../assets/images/uti.png";
import "./TreatmentCards.css";

const TreatmentCards = () => {
  return (
    <section className="container py-5">

      {/* Section Title */}
      <h2 className="text-center mb-5 fw-bold">
        Our Treatments
      </h2>

      <div className="row">

        {/* Kidney Stone */}
        <div className="col-md-3 col-6 mb-4">
          <div className="card border-0 shadow-sm text-center p-4 h-100">

            <img
              src={kidney}
              alt="Kidney Stone Treatment"
              style={{ width: "60px", margin: "auto" }}
            />

            <h5 className="mt-3">
              Kidney Stone
            </h5>

            <p className="text-muted small">
              Advanced treatment for kidney stone removal.
            </p>

          </div>
        </div>

        {/* Prostate */}
        <div className="col-md-3 col-6 mb-4">
          <div className="card border-0 shadow-sm text-center p-4 h-100">

            <img
              src={prostate}
              alt="Prostate Treatment"
              style={{ width: "60px", margin: "auto" }}
            />

            <h5 className="mt-3">
              Prostate Care
            </h5>

            <p className="text-muted small">
              Modern prostate diagnosis and treatment.
            </p>

          </div>
        </div>

        {/* Male Infertility */}
        <div className="col-md-3 col-6 mb-4">
          <div className="card border-0 shadow-sm text-center p-4 h-100">

            <img
              src={infertility}
              alt="Male Infertility"
              style={{ width: "60px", margin: "auto" }}
            />

            <h5 className="mt-3">
              Male Infertility
            </h5>

            <p className="text-muted small">
              Expert consultation and fertility solutions.
            </p>

          </div>
        </div>

        {/* UTI */}
        <div className="col-md-3 col-6 mb-4">
          <div className="card border-0 shadow-sm text-center p-4 h-100">

            <img
              src={uti}
              alt="UTI Treatment"
              style={{ width: "60px", margin: "auto" }}
            />

            <h5 className="mt-3">
              UTI Treatment
            </h5>

            <p className="text-muted small">
              Complete care for urinary tract infections.
            </p>

          </div>
        </div>

      </div>

    </section>
  );
};

export default TreatmentCards;